import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

const FlowsDoc = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box style={{
            display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, overflowY: 'auto',
            p: 3
        }}>
            <Typography variant="body1" style={{ width: isMediumScreen ? '100%' : '40%' }}>
                <strong>API Flows</strong>
                <br /><br />

                <p>
                    Create API flows to run complete simulations effortlessly. Use the <strong>Add Request</strong> button to add requests and the <strong>Start</strong> button to insert the starting node.
                </p>
            </Typography>
            <img
                src="/flows/APIFlows.png"
                alt="validations"
                style={{
                    width: isMediumScreen ? '100%' : '80%',
                    // maxWidth: '800px',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                }}
            />
        </Box>
    )
};

export default FlowsDoc;